import type { StateGroup } from '@staiter/shared/task-module';

/**
 * F10 (work-tasks-user-feedback §3.2) [П18] — миграция сохранённых наборов групп
 * НА ЧТЕНИИ.
 *
 * ЧТО БЫЛО БЫ СЛОМАНО. Группа `paused` появилась после того, как люди уже
 * насохраняли виды и наделали ссылок с `state_groups=...`. В каждом таком наборе
 * её нет — и задача, поставленная на паузу, исчезала бы из вида навсегда, тихо и
 * необъяснимо: человек видит свой обычный фильтр «активные», а работы в нём нет.
 *
 * Мигрировать хранилище разово нельзя: те же наборы живут в URL — в закладках, в
 * переписке, в письмах. Поэтому правило применяется на КАЖДОМ чтении, а не один
 * раз при выкате.
 *
 * Правило узкое намеренно: `paused` добавляется ТОЛЬКО туда, где есть `started`.
 * Набор со `started` — это «покажи работу, которая идёт»; пауза от неё
 * неотделима. Набор без `started` (например, только `completed`) человек собрал
 * осознанно, и дополнять его — значит переписывать чужой выбор.
 */
export function migrateStateGroups<T extends string>(groups: readonly T[]): T[] {
  const list = [...groups];
  const hasStarted = list.includes('started' as T);
  const hasPaused = list.includes('paused' as T);
  if (!hasStarted || hasPaused) return list;
  // Позиция та же, что в контракте порядка групп: сразу за `started`.
  const at = list.indexOf('started' as T);
  list.splice(at + 1, 0, 'paused' as T);
  return list;
}

/** Тот же перевод для типизированного набора групп. */
export function migrateStateGroupList(groups: readonly StateGroup[]): StateGroup[] {
  return migrateStateGroups(groups);
}
